'use client';

export default function LegalLayout({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
